import CryptoJS from 'crypto-js'
import { AesUtil } from './AesUtil';

export const fetchSessionToken = () => {
    let clientID = localStorage.getItem("clientId") || sessionStorage.getItem("clientId") || process.env.REACT_APP_CLIENT_CONFIG//
    // "GJ_AEDBIME"; // Melia
     //   "GJ_CLIENTID"
    //  "GJ_SESTHMA"
    // "GJ_MVNONCB"
    // 'GJ_MUBEOTM' // Tamassa
    // 'GJ_USTPADC' // DonCesar
    // 'GJ_CARICVH' // Versante

    let deviceID, encodedData;
    let platform;
    try {
        if (window.cordova) {
            deviceID = window.device.uuid;
            platform = window.device.platform;
            //alert(`deviceID:${deviceID}platform:${platform}`);
        } else {
            let uuid = new Date().getTime(); //"1657618521780" // 
            deviceID = `${uuid}`;
            platform = "browser";
        }
        let iv = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
        let salt = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
        let aesUtil = new AesUtil(128, 1000);
        let ciphertext = aesUtil.encrypt(
            salt,
            iv,
            "1234567891234567",
            `${clientID}&${platform}&${deviceID}`
        );
        console.log("data", salt, " @ ",
            iv, " @ ",
            "1234567891234567", " @ ",
            `${clientID}&${platform}&${deviceID}`)
        console.log("ciphertext", ciphertext);
        let keyAndCipher = (iv + "::" + salt + "::" + ciphertext);
        encodedData = btoa(keyAndCipher);
    } catch (err) {
        console.log("error in encryption process", err);
    }
    return { encodedData, deviceID };
}

const encryptData = (salt, iv) => {
    let aesUtil = new AesUtil(128, 1000);
    let ciphertext = aesUtil.encrypt(
        salt,
        iv,
        "1234567891234567",
        `data to encrypt`
    );
    return ciphertext;
}